import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Header from "./components/Header";
import Navbar from './components/Navbar';
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Products from "./pages/Products";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Blogs from "./pages/Blogs";
import FAQ from './pages/Faq';
import Careers from './pages/Careers';
import { Disclaimer, CookiePolicy } from "./pages/Policies";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import TermsOfService from "./pages/TermsOfService";

import AffordableOrganicPeriodCare from "./pages/blogs/AffordableOrganicPeriodCare";
import WhyChooseOrganicPads from "./pages/blogs/WhyChooseOrganicPads";
import EcoFriendlyPeriodCare from "./pages/blogs/EcoFriendlyPeriodCare";
import EnvironmentalImpectOfTraditionalPads from './pages/blogs/EnvironmentalImpectOfTraditionalPads';
import ExerciseSportsDuringPeriodOrganic from './pages/blogs/ExerciseSportsDuringPeriodOrganic';
import FutureOfMenstrualCare from './pages/blogs/FutureOfMenstrualCare';
import HealthRisksConventionalPads from './pages/blogs/HealthRisksConventionalPads';
import HormonesMenstruationOrganicProducts from './pages/blogs/HormonesMenstruationOrganicProducts';
import UnderstandingPeriodHealth from './pages/blogs/UnderstandingPeriodHealth';
import OrganicPadsSensitiveSkin from './pages/blogs/OrganicPadsSensitiveSkin';
import ReduceMenstrualWasteOrganicPads from './pages/blogs/ReduceMenstrualWasteOrganicPads';
import OrganicPadsFeminineHygiene from './pages/blogs/OrganicPadsFeminineHygiene';
import OrganicPadsSupportWomensHealth from './pages/blogs/OrganicPadsSupportWomensHealth';
import ManagingHeavyPeriodsOrganicSolutions from './pages/blogs/ManagingHeavyPeriodsOrganicSolutions';
import MenstrualAllergiesOrganicSolutions from './pages/blogs/MenstrualAllergiesOrganicSolutions';
import NaturalPeriodPainManagement from './pages/blogs/NaturalPeriodPainManagement';
import OvernightProtectionOrganicPads from './pages/blogs/OvernightProtectionOrganicPads';
import PeriodTravelOrganicSolutions from './pages/blogs/PeriodTravelOrganicSolutions';
import PostPregnancyPeriodCare from './pages/blogs/PostPregnancyPeriodCare';
import TeensFirstPeriodOrganicGuide from './pages/blogs/TeensFirstPeriodOrganicGuide';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/faqs" element={<FAQ />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/terms-of-use" element={<TermsOfService />} />

        <Route path="/affordable-organic-period-care" element={<AffordableOrganicPeriodCare />} />
        <Route path="/why-choose-organic-pads" element={<WhyChooseOrganicPads />} />
        <Route path="/eco-friendly-period-care" element={<EcoFriendlyPeriodCare />} />
        <Route path="/environmental-impact-traditional-pads" element={<EnvironmentalImpectOfTraditionalPads/>}/>
        <Route path="/exercise-sports-during-period-organic" element={<ExerciseSportsDuringPeriodOrganic/>}/>
        <Route path="/future-of-menstrual-care" element={<FutureOfMenstrualCare/>}/>
        <Route path="/health-risks-conventional-pads" element={<HealthRisksConventionalPads/>}/>
        <Route path="/hormones-menstruation-organic-products" element={<HormonesMenstruationOrganicProducts/>}/>
        <Route path="/understanding-period-health" element={<UnderstandingPeriodHealth/>}/>
        <Route path="/organic-pads-sensitive-skin" element={<OrganicPadsSensitiveSkin/>}/>
        <Route path="/reduce-menstrual-waste-organic-pads" element={<ReduceMenstrualWasteOrganicPads/>}/>
        <Route path="/organic-pads-feminine-hygiene" element={<OrganicPadsFeminineHygiene/>}/>"
        <Route path="/organic-pads-support-womens-health" element={<OrganicPadsSupportWomensHealth/>}/>
        <Route path="/managing-heavy-periods-organic-solutions" element={<ManagingHeavyPeriodsOrganicSolutions/>}/>
        <Route path="/menstrual-allergies-organic-solutions" element={<MenstrualAllergiesOrganicSolutions/>}/>
        <Route path="/natural-period-pain-management" element={<NaturalPeriodPainManagement/>}/>
        <Route path="/overnight-protection-organic-pads" element={<OvernightProtectionOrganicPads/>}/>
        <Route path="/period-travel-organic-solutions" element={<PeriodTravelOrganicSolutions/>}/>
        <Route path="/post-pregnancy-period-care" element={<PostPregnancyPeriodCare/>}/>
        <Route path="/teens-first-period-organic-guide" element={<TeensFirstPeriodOrganicGuide/>}/>
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;